import { Alert } from "@mui/material";
import React from "react";
import { FC } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import { FormattedMessage } from "react-intl";

interface ReservationAlertProps {
	requiresFee: boolean;
	paymentStatus: string | null;
	fee?: number;
}

const ReservationAlert: FC<ReservationAlertProps> = ({
	requiresFee,
	paymentStatus,
	fee,
}) => {
	return (
		<Alert
			severity={
				!requiresFee || paymentStatus === "approved"
					? "success"
					: paymentStatus === "rejected"
					? "error"
					: "info"
			}
			color={
				!requiresFee || paymentStatus === "approved"
					? "success"
					: paymentStatus === "rejected"
					? "error"
					: "warning"
			}
			variant="filled"
			icon={
				!requiresFee || paymentStatus === "approved" ? (
					<CheckCircleIcon />
				) : paymentStatus === "rejected" ? (
					<ErrorIcon />
				) : (
					<InfoIcon />
				)
			}
			sx={{
				width: "100%",
			}}
		>
			{!requiresFee ? (
				/* If the reservation is made and don't requires fee, we show success message. */
				<FormattedMessage
					id="details.success"
					defaultMessage="Reserva realizada con éxito."
				/>
			) : paymentStatus && paymentStatus === "approved" ? (
				/* If the reservation is made and the payment is approved, we show payment success. */
				<FormattedMessage
					id="details.paymentSuccess"
					defaultMessage="Reserva realizada con éxito, pago recibido!"
				/>
			) : paymentStatus && paymentStatus === "rejected" ? (
				/* If the reservation is made and the payment is rejected, we show error. */
				<FormattedMessage
					id="details.paymentError"
					defaultMessage="Pago rechazado. Intente de nuevo."
				/>
			) : paymentStatus &&
			  ["in_process", "authorized", "pending", "processing"].includes(
					paymentStatus
			  ) ? (
				/* If the payment is in process, we show a message informing that. */
				<FormattedMessage
					id="details.paymentInProcess"
					defaultMessage="Se está procesando el pago."
				/>
			) : (
				paymentStatus === "not_generated" && (
					/* If there is not paymentStatus, it means that payment have not
					been done. */
					<>
						<FormattedMessage
							id="details.success.requiresFee1"
							defaultMessage="Reserva realizada con éxito, se requiere una seña de $"
						/>
						{fee}
						<FormattedMessage
							id="details.success.requiresFee2"
							defaultMessage=" "
						/>
					</>
				)
			)}
		</Alert>
	);
};

export default ReservationAlert;
